import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Navbar from "components/Navbars/Navbar";
import "assets/scss/app.scss";
import sidebar_routes from "sidebar_routes";
import Scrollbar from "react-scrollbars-custom";
import Footer from "components/Footer";
import routes from "routes.js";
import { useGlobalContext } from "store/contexts/globalContext";
import Sidebar from "components/Sidebar/Sidebar";

export default ({ ...rest }) => {
  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;
  const isSiteAdmin = user && user.roles && user.roles.includes("Site Admin");

  const filteredRoutes = routes.filter(route => route.name !== "Support Ticket" || isSiteAdmin);

  const [adminRoutes] = useState([...filteredRoutes, ...sidebar_routes]);
  const { microsoftConfigureTab } = useGlobalContext();
  const [mobileLeftSidebarOpen, setMobileLeftSidebarOpen] = useState(false);

  useEffect(() => {
    if (microsoftConfigureTab) {
      microsoftTeams.app.notifySuccess();
    }
  }, [microsoftConfigureTab]);

  const switchRoutes = (
    <Switch>
      {adminRoutes.map((prop, key) => {
        return (
          <Route
            path={prop.layout + prop?.path}
            component={prop?.component}
            key={key}
            exact={prop.name !== "Polls"}
          />
        );
      })}
      {!microsoftConfigureTab && <Redirect from="/" to="/teams" />}
      {microsoftConfigureTab && <Redirect from="/" to="/integrations" />}
    </Switch>
  );

  const handleLeftSidebarDrawer = () => {
    setMobileLeftSidebarOpen(!mobileLeftSidebarOpen);
  };

  return (
    <>
      <Navbar
        routes={filteredRoutes}
        {...rest}
        handleLeftSidebarDrawer={handleLeftSidebarDrawer}
      />
      <Sidebar
        open={mobileLeftSidebarOpen}
        routes={sidebar_routes}
        closeLeftDrawer={handleLeftSidebarDrawer}
      />
      <div className="dashboard teams-page">
        <Scrollbar>
          <div className="content">
            <div className="row justify-content-md-center">{switchRoutes}</div>
          </div>
        </Scrollbar>
      </div>
      {!microsoftConfigureTab && <Footer routes={filteredRoutes} />}
    </>
  );
};
